export default "__VITE_ASSET__B$opHFQA__"